import FeatureRenderer from './FeatureRendererType'

export default class CircularChordRendererType extends FeatureRenderer {}
